








































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Stars from '@/components/atoms/Stars/Stars.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';

@Component({
  components: {
    Stars,
    Input
  }
})
export default class Rating extends Vue {
  @Prop({ default: 5 }) stars!: number;
  @Prop({ default: 0 }) rating!: number;
  @Prop({ default: '' }) comment!: string;

  ratingStatus = ['bad', 'notGood', 'regular', 'good', 'amazing'];

  onChangeRate(rate: number) {
    this.$emit('changeRate', rate);
  }

  get tPrefix() {
    return 'common.components.feedback';
  }

  get firstname() {
    if (
      !this.business ||
      !this.business.manager ||
      !this.business.manager.fullname
    )
      return 'Manager';
    return this.business.manager.fullname.split(' ')[0];
  }

  get messageStatus() {
    if (this.rating <= 2) return 'bad';
    return 'good';
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }
}
